
import { defineComponent, ref, watch } from "vue";
import { hideModal } from "@/core/helpers/dom";
import { ApiBase, ApiWechatCommunity } from "@/core/api";
import mixin from "@/mixins";
import _ from "lodash";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "add-member-modal",
  props: {
    id: { type: Number, default: 0 },
    parentId: { type: Number, default: 0 },
  },
  components: {},
  emits: ["update-list", "reset-form"],
  setup(props, { emit }) {
    const loading = ref<boolean>(false);
    const formRef = ref<null | HTMLFormElement>(null);
    const addMemberModalRef = ref<null | HTMLElement>(null);
    const submitButton = ref<HTMLElement | null>(null);
    const { t } = useI18n();

    const {
      showValidateErrorMsg,
      showFormSubmitSuccessMsg,
      showServerErrorMsg,
    } = mixin();

    const formData = ref({
      wechat_community_id: props.parentId,
      account_id: "",
    });

    const rules = ref({
      account_id: [
        {
          required: true,
          message: t("common.isRequired"),
          trigger: "change",
        },
      ],
    });

    watch(
      () => props.id,
      (newVal) => {
        if (newVal) {
          // getFormData(newVal);
        } else {
          resetForm();
        }
      }
    );
    const accountOptions = ref([]);
    const accountLoading = ref<boolean>(false);

    const getAccountSourceData = async (value?: string) => {
      accountLoading.value = true;
      let params =
        value != ""
          ? {
              search_value: value,
            }
          : {};
      const { data } = await ApiBase.getAccountSourceData(params);
      accountLoading.value = false;
      if (data.code == 0) {
        accountOptions.value = data.data;
      }
    };
    const debounceAccountSearch = _.debounce(getAccountSourceData, 1000);
    const searchAccountItems = (query) => {
      debounceAccountSearch(query);
    };

    const submit = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate((valid) => {
        if (valid) {
          loading.value = true;
          if (submitButton.value) {
            submitButton.value.setAttribute("data-kt-indicator", "on");
          }
          ApiWechatCommunity.addWechatCommunityMember(formData.value)
            .then(({ data }) => {
              loading.value = false;
              submitButton.value?.removeAttribute("data-kt-indicator");
              if (data.code == 0) {
                showFormSubmitSuccessMsg(() => {
                  resetForm();
                  hideModal(addMemberModalRef.value);
                  emit("update-list");
                });
              } else {
                showServerErrorMsg(data);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          showValidateErrorMsg();
          return false;
        }
      });
    };

    const handleDiscard = () => {
      hideModal(addMemberModalRef.value);
      resetForm();
      emit("reset-form");
    };

    const resetForm = () => {
      formRef.value?.resetFields();
    };

    return {
      loading,
      formData,
      rules,
      formRef,
      addMemberModalRef,
      submitButton,
      accountOptions,
      accountLoading,
      t,
      searchAccountItems,
      submit,
      handleDiscard,
      resetForm,
    };
  },
});
